module.exports = __webpack_public_path__ + "media/icons/check@3x-e20d935c.svg";